const zIndex = {
  overlay: 10,
  sidebar: 20,
};

export { zIndex };
